import { combineReducers } from 'redux';

const initialState = {
  loggedIn: false,
  address: null,
  project: null,
  stage: 2
};

const appReducer = (state = initialState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case 'LOGIN':
      return{
        ...state,
        loggedIn: true,
        address: '0xfab5b234b8a92823c73ee01a'
      }
    case 'LOGOUT':
      return{
        ...state,
        loggedIn: false,
        address: null,
        project: null
      }
    case 'SET_PROJECT':
      return{
        ...state,
        project: payload,
        stage: 2
      }
    case 'NEXT_STAGE':
      return{
        ...state,
        stage: state.stage<5?state.stage+1:state.stage
      }
    case 'RESET_BALANCE':
      return {
        ...state,
        balance: payload,
      }
    case 'UPDATE_PLAYER_BET':
      return {
        ...state,
        playerBets: payload,
        betType: 'Player'
      }
    case 'UPDATE_BANKER_BET':
      return {
        ...state,
        bankerBets: payload,
        betType: 'Banker'
      }
    case 'UPDATE_TIE_BET':
      return {
        ...state,
        tieBets: payload,
        betType: 'Tie'
      }
    case 'UPDATE_PLAYER_DRAGON_BETS':
      return {
        ...state, playerDragonBets: payload,  currentSideBetType: 'Player Dragon',
      }
    case 'UPDATE_BANKER_DRAGON_BETS':
      return {
        ...state, bankerDragonBets: payload, currentSideBetType: 'Banker Dragon',
      }
    case 'UPDATE_PERFECT_PAIR_BETS':
      return {
        ...state, perfectPairBets: payload, currentSideBetType: 'Perfect Pair',
      }
    case 'CLEAR_SIDE_BET_TYPE':
      return {
        ...state,
        currentSideBetType: '',
        playerDragonBets: 0,
        bankerDragonBets: 0,
        perfectPairBets: 0,
      }
    case 'SAVE_CARDS':
      return {
        ...state,
        playerCards: payload.playerCards,
        bankerCards: payload.bankerCards,
        gameState: 'end'
      }
    case 'SAVE_RESULT':
      return {
        ...state,
        result: payload,
      }
    case 'SAVE_SIDEBET_RESULT':
      return {
        ...state,
        sideBetResult: payload,
      }
    case 'SAVE_PAYOUT':
      return {
        ...state,
        payout: payload,
      }
    case 'RESET_GAME_STATE':
      return {
        ...state,
        gameState: 'initial',
        playerCards: [],
        bankerCards: [],
        playerBets: 0,
        bankerBets: 0,
        tieBets: 0,
        currentSideBetType: '',
        playerDragonBets: 0,
        bankerDragonBets: 0,
        perfectPairBets: 0,
        betType: null,
        result: '',
        payout: 0,
      }
    case 'RESET_FOR_REBET':
      return {
        ...state,
        gameState: 'initial',
        playerCards: [],
        bankerCards: [],
        result: '',
        payout: 0
      }
    case 'SET_TRANSACTION_IN_PROGRESS':
      return {
        ...state,
        transactionInProgress: payload,
      }
    case 'SAVE_LAST_TEN_HANDS':
      return {
        ...state,
        lastTenHands: payload,
      }
    case 'SET_SHOW_ACTION_BTNS':
      return {
        ...state,
        showActionBtns: payload,
      }
    case 'SET_AUTO_BET':
      return {
        ...state,
        autoBetPlaced: payload,
      }
    case 'RESET_ALL_BETS':
      return {
        ...state,
        playerBets: 0,
        bankerBets: 0,
        tieBets: 0,
        playerDragonBets: 0,
        bankerDragonBets: 0,
        perfectPairBets: 0,
      }
    case 'SET_SIDEBET_BLINK':
      return {
        ...state,
        playerDragonBlink: payload.playerDragon,
        bankerDragonBlink: payload.bankerDragon,
        perfectPairBlink: payload.perfectPair,
      }
    case 'SHOW_SHUFFLE_ANIMATION':
      return {
        ...state,
        shuffleAnimation: payload
      }
    case 'SET_WALLET_ADDRESS':
      return {
        ...state,
        walletAddress: payload
      }
    case 'SHOW_BALANCE_MODAL':
      return {
        ...state,
        balanceModalShown: payload,
      }
    case 'RESET_SIDEBET_BLINK':
      return {
        ...state,
        playerDragonBlink: false,
        bankerDragonBlink: false,
        perfectPairBlink: false,
      }
    default:
      return state;
  }
};

export const rootReducer = combineReducers({ appReducer });
